import { render } from "./HumanDarkSvg.vue?vue&type=template&id=c9eda7e8"
import script from "./HumanDarkSvg.vue?vue&type=script&lang=js"
export * from "./HumanDarkSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__